import React, { useState } from 'react';
import GridTemplateConfigurationController from '../grid-template-config.controller';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { Utility } from '../../../../common/utility';
import { observer } from 'mobx-react';
import { TemplateSFObjectStore } from '../../../../store/models/template-object.model';
import { IFieldData } from '../../component-level-fields/component-field';

interface IProps { 
    selectedTemplateName: string;
    updateViewSourceComponentConfig: Function;
    fieldInfo: IFieldData;
}

const GridSuffix = (props: IProps) => {
    const util: Utility = new Utility();
    const outputConfig = CQMasterDataStore.OutputConfig;
    const viewSourceComponentConfig = CQMasterDataStore.GridObject.gridComponentConfigView;
    
    const [suffix, setSuffix] =  useState(viewSourceComponentConfig.suffix);
    
    React.useEffect(() => {
        
        if (Object.keys(viewSourceComponentConfig).length !== 0) {
            let { objectApiName, limitToRecordType } = outputConfig.getStoreData(props.selectedTemplateName);
            const childObject = TemplateSFObjectStore.sfObjects.filter((sfObject: any) => {
                return sfObject.name === objectApiName;
            });
            let childObjectApiName: string = (childObject.length && childObject[0].name) as string;
            if (childObjectApiName && childObjectApiName.includes('__c')) {
                childObjectApiName = childObjectApiName.replace('__c', '');
            }
            childObjectApiName = util.toPascalCase(childObjectApiName);
            const recordTypeName = limitToRecordType;
            let compName = '';
            const prefix = viewSourceComponentConfig.prefix ? viewSourceComponentConfig.prefix : '';
            if (childObject.length) {
                if (suffix) {
                    compName = `cqui${prefix}${childObjectApiName}${suffix}Grid`;
                } else {
                    compName = `cqui${prefix}${childObjectApiName}Grid`;
                }
                props.updateViewSourceComponentConfig('suffix', suffix, compName,suffix);
            } else {
                props.updateViewSourceComponentConfig('suffix', suffix);
            }
        }
    }, [suffix]);
    return (
        <div className="slds-form-element">
            <label className="slds-form-element__label">{props.fieldInfo.name}</label>
            <div className="slds-form-element__control">
                <input type="text" placeholder="Placeholder Text" className="slds-input"
                    onChange={(e: any) => setSuffix(e.target.value)} value={viewSourceComponentConfig.suffix} />
            </div>
        </div>
    );
}

export const GridComponentSuffix = observer(GridSuffix);